import { useSuspenseQuery } from "@apollo/client/react";
import React from "react";
import {
  GetDataImportProjectsModelContextDocument,
  type GetDataImportProjectsModelContextQuery,
  type GetDataImportProjectsModelContextQueryVariables,
} from "~/features/dataImportProjects/gqls";
import { useTenant } from "~/features/tenant/context";

interface DataImportProjectsModelContextInterface {
  users: { id: string; displayName?: string | null | undefined; email: string }[];
  references: { id: string; title: string }[];
  dataImportProjectStatuses: { id: string }[];
  dataImportProjectStatusLogs: { id: string; statusId: string }[];
  dataSourceTemplates: { id: string; name: string }[];
  categories: { id: string; name: string }[];
}

const DataImportProjectsModelContext = React.createContext<DataImportProjectsModelContextInterface>({
  users: [],
  references: [],
  dataImportProjectStatuses: [],
  dataImportProjectStatusLogs: [],
  dataSourceTemplates: [],
  categories: [],
});

export const useDataImportProjectsModel = () => React.useContext(DataImportProjectsModelContext);

interface Props {
  children: React.ReactNode;
}

export const DataImportProjectsModelProvider: React.FC<Props> = ({ children }) => {
  const { tenantId } = useTenant();
  if (!tenantId) {
    throw new Error("Tenant ID is required");
  }

  const { data } = useSuspenseQuery<
    GetDataImportProjectsModelContextQuery,
    GetDataImportProjectsModelContextQueryVariables
  >(GetDataImportProjectsModelContextDocument, {
    variables: { tenantId },
  });

  return (
    <>
      {data && (
        <DataImportProjectsModelContext.Provider value={{ ...data }}>
          {children}
        </DataImportProjectsModelContext.Provider>
      )}
    </>
  );
};
